import type { SidebarItem } from '../components/Sidebar'

// V1 entegrasyon: Wallet üst başlık + 3 alt menu (Madde #11 Volkan onaylı 2026-05-23).
// Admin + supply shell'leri ortak kullanır (seller kendi menüsünü SellerShell'de tanımlar); shell-specific data filtering page içinde.
// Detay: planning/plans/v1-scope-expansion-2026-05-23.md #11 + nodes/components/wallet.md UI Surface section.
// `groupLabel` is the collapsible group's own label. Admin renames it to
// "Finance & Wallet" because PEXIFY's corporate Bank account lives in that group
// (2026-09-06); supply has no Bank surface, so it keeps "Wallet".
export const walletSidebarItems = (
  shellPrefix: '/admin' | '/supply',
  groupLabel = 'Wallet',
): SidebarItem[] => {
  const groupId = `wallet-${shellPrefix.replace('/', '')}`
  return [
    {
      to: `${shellPrefix}/wallet`,
      label: groupLabel,
      icon: 'navWallet',
      groupId,
    },
    // On admin the group head already opens the same Payments screen, so a
    // separate "Payments" child would be a second link to one page
    // (admin menu simplification, Volkan 2026-10-05).
    ...(shellPrefix === '/admin'
      ? []
      : [
          {
            to: `${shellPrefix}/wallet/payments`,
            label: 'Payments',
            icon: 'payments',
            parentGroupId: groupId,
          } satisfies SidebarItem,
        ]),
    // Payout setup (Stripe Connect) is for anyone PEXIFY pays OUT — here the
    // supply partners taking their earnings (sellers reach it elsewhere). The
    // admin surface is the platform wallet; it is not paid out to.
    ...(shellPrefix === '/admin'
      ? []
      : [
          {
            to: `${shellPrefix}/wallet/payouts`,
            label: 'Stripe payouts',
            icon: 'banking',
            parentGroupId: groupId,
          } satisfies SidebarItem,
        ]),
    // Manual payout bank accounts belong to whoever PEXIFY pays OUT (supply).
    // The admin side is the approval queue for those accounts.
    ...(shellPrefix === '/admin'
      ? [
          {
            to: `${shellPrefix}/wallet/bank-approvals`,
            label: 'Bank Approvals',
            icon: 'banking',
            parentGroupId: groupId,
          } satisfies SidebarItem,
        ]
      : [
          {
            to: `${shellPrefix}/wallet/banking`,
            label: 'Bank account',
            icon: 'banking',
            parentGroupId: groupId,
          } satisfies SidebarItem,
        ]),
    // Partner weekly 50/50 profit-share settlement — admin Ring 3 operator
    // surface only (monetization §6c). Monetization config moved beside
    // Pricing Hub in the Catalog group (2026-09-13); the Stripe keys screen
    // (Payment Gateways) is set-and-forget config and lives in Settings
    // (2026-10-05).
    ...(shellPrefix === '/admin'
      ? [
          {
            to: `${shellPrefix}/partner-settlements`,
            label: 'Partner Settlements',
            icon: 'settlement',
            parentGroupId: groupId,
          } satisfies SidebarItem,
        ]
      : []),
  ]
}
